import {atom} from "recoil";
import {CommercialCategorySelectFE} from "../api/types/commercialCategory";

export const commercialCategoryListAtom = atom<CommercialCategorySelectFE[]>({
    key: "commercialCategoryListAtom",
    default: []
});